module.exports = __webpack_public_path__ + "static/scale-model-of-escape-in-time---escape-rooms-in-madison-wisconsin-b3ca0f2bcc08536ea4e477325d65a184.png";